import type { RouteObject } from 'react-router';

import * as searchOrgsHorizonRouteExports from '#/modules/search/orgs/page/SearchOrgs.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchOrgsRoutePaths } from './searchOrgs.route-paths';

export const searchOrgsRouteObjects = searchOrgsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchOrgsHorizonRouteExports),
})) satisfies RouteObject[];
